import { render, staticRenderFns } from "./recentLiveCourse.vue?vue&type=template&id=11b46d5d&scoped=true&"
import script from "./recentLiveCourse.vue?vue&type=script&lang=js&"
export * from "./recentLiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./recentLiveCourse.vue?vue&type=style&index=0&id=11b46d5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b46d5d",
  null
  
)

export default component.exports